import { render, staticRenderFns } from "./allrequest.vue?vue&type=template&id=32f65d4c"
import script from "./allrequest.vue?vue&type=script&lang=js"
export * from "./allrequest.vue?vue&type=script&lang=js"
import style0 from "./allrequest.vue?vue&type=style&index=0&id=32f65d4c&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports